<template>
  <div class="box" ref="cos">
    <div class="main-top">
      <img src="@/assets/logo-m.png" class="logo-m" @click="toMain" alt="" />
      <div>
        <el-row :gutter="72">
          <el-col :span="4" v-for="(item, index) in tabList" :key="index">
            <div
              :class="{ 'top-title': true, checked: item.check == true }"
              @click="tabCheck(item, index)"
            >
              {{ item.name }}
            </div>
            <transition name="el-zoom-in-center">
              <div class="line" v-show="item.check == true"></div>
            </transition>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- <div class="topImg">
      <el-carousel
        indicator-position="none"
        height="600px"
        arrow="never"
        ref="carousel"
      >
        <el-carousel-item v-for="(item, index) in imgList" :key="index">
          <div style="positions: relative">
            <img :src="item.url" alt="" class="itemImg" srcset="" />
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="clickIt">
        <div
          :class="{ cliItem: true, actClick: item.check == true }"
          v-for="(item, index) in imgList"
          :key="index"
          @click="changeCar(index)"
        ></div>
      </div>
    </div> -->
    <router-view ref="routerView"></router-view>
    <div class="allBot">
      <div class="scorlLeft">
        <div class="scorLi">
          <div
            class="scorTitle"
            style="color: #fff; font-size: 18px; padding-bottom: 36px"
            @click="toMains(0)"
          >
            <span>首页</span>
          </div>
          <div class="scorTitle" @click="toMains(1)">公司概述</div>
          <div class="scorTitle" @click="toMains(2)">业务板块</div>
          <div class="scorTitle" @click="toMains(3)">使命 愿景 价值观</div>
        </div>
        <div class="scorLi">
          <div
            class="scorTitle"
            style="color: #fff; font-size: 18px; padding-bottom: 36px"
            @click="toProduct(0)"
          >
            <span>产品介绍</span>
          </div>
          <div class="scorTitle" @click="toProduct(1)">产品简介</div>
          <div class="scorTitle" @click="toProduct(2)">产品功能</div>
          <div class="scorTitle" @click="toProduct(3)">产品安全</div>
          <div class="scorTitle" @click="toProduct(4)">扫码下载 APP</div>
        </div>
        <div class="scorLi">
          <div
            class="scorTitle"
            style="color: #fff; font-size: 18px; padding-bottom: 36px"
            @click="toNews(0)"
          >
            <span>新闻活动</span>
          </div>
          <div class="scorTitle" @click="toNews(1)">新闻热点</div>
          <div class="scorTitle" @click="toNews(2)">公司活动</div>
          <div class="scorTitle" @click="toNews(3)">其他活动</div>
        </div>
        <div class="scorLi">
          <div
            class="scorTitle"
            style="color: #fff; font-size: 18px; padding-bottom: 36px"
            @click="toVideo(0)"
          >
            <span>视频中心</span>
          </div>
          <div class="scorTitle" @click="toVideo(1)">公司宣传片</div>
          <div class="scorTitle" @click="toVideo(2)">专题纪录片</div>
          <div class="scorTitle" @click="toVideo(3)">小视频分享</div>
        </div>
        <div class="scorLi">
          <div
            class="scorTitle"
            style="color: #fff; font-size: 18px; padding-bottom: 36px"
            @click="toServe(0)"
          >
            <span>服务中心</span>
          </div>
          <div class="scorTitle" @click="toServe(1)">建议留言</div>
          <div class="scorTitle" @click="toServe(2)">扫码关注</div>
        </div>
      </div>
      <div class="scorlRight">
        <div class="scorRi">
          <div
            class=""
            style="color: #fff; padding-bottom: 36px; font-size: 18px"
          >
            联系我们
          </div>
          <div class="scorTitle">400-0026-028</div>
        </div>
      </div>
    </div>
    <div class="friendly-link" v-if="friendLinkData.length>0">
      <div class="link-top">友情链接</div>
      <div class="link-box">
        <div class="link-item"  v-for="(item, index) in friendLinkData" :key="index" @click="goLink(item)">
        <span :keyword="item.linkName">{{item.linkName}}</span>
        </div>
      </div>
    </div>
    <div
      class="botBei"
      style="
        padding: 20px 0;
        background: #201f45;
        color: #999da6;
        font-size: 16px;
      "
    >
      深圳市龙胤网络科技有限公司
      <img src="@/assets/beian.png" class="beianImg" alt="" />
      <a
        style="margin-left: 5px"
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        >粤公网安备44030902004069号</a
      >
      <a
        style="margin-left: 40px"
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        >粤ICP备2023005051号</a
      >
    </div>
  </div>
</template>

    <script>
import { getDate,friendLink,setAction } from "@/api/request";
import "./main.css";
export default {
  name: "navBars",
  components: {},
  data() {
    return {
      tabList: [
        { name: "公司概况", check: false, url: "/" },
        { name: "产品介绍", check: false, url: "/products" },
        { name: "新闻活动", check: false, url: "/news" },
        { name: "视频中心", check: false, url: "/video" },
        { name: "服务中心", check: false, url: "/serve" },
        { name: "联系我们", check: false, url: "/contect" },
      ],
      showLinkFri: true,
      friendLinkData:[],
    };
  },
  created() {

    this.tabList.map((e) => {
      if (e.url == this.$route.path) {
        e.check = true;
      }
      if (this.$route.path == "/newsMain" && e.url == "/news") {
        e.check = true;
      }
    });
    this.getFriendLink()
  },
  mounted() {
  },
  watch: {
    // 监听，当路由发生变化的时候执行
    $route(to, from) {
      console.log("路由变化了");
      console.log("当前页面路由：" , to.path);
      console.log("上一个路由：" + from.path);
      this.tabList.map((item,index)=>{
        if(item.url==to.path){
          item.check = true;
        }else{
          item.check = false;

        }
      })
      if (to.path == "/") {
        this.showLinkFri = true;
      } else {
        this.showLinkFri = false;
      }
    },
  },
  methods: {
    getFriendLink() {
      friendLink().then((res) => {
        console.log(res,"res----")
         this.friendLinkData = res.data.result;
      });
    },
    getDate() {
      let data = {
        dictType: 1,
      };
      getDate(data).then((res) => {
        console.log(res);
      });
    },
    tabCheck(e, i) {
      // this.$refs.carousel.setActiveItem(i);
      if (this.tabList[i].check == true) {
        this.tabList[i].check = false;
      } else {
        this.tabList[i].check = true;
      }
      this.tabList.map((a, j) => {
        if (i != j) {
          this.tabList[j].check = false;
        } else {
          this.tabList[j].check = true;
        }
      });
      if (e.url && e.url != this.$route.path) {
        this.$router.push({ path: e.url });
      }
    },
    toMain() {
      if (this.$route.path != "/") {
        this.$router.push({ path: "/" });
        this.tabList[0].check = true;
        this.tabList.filter((e, i) => {
          if (i != 0) return (e.check = false);
        });
      }
    },
    toMains(e) {
      let data = {
        url: "/",
      };
      this.tabCheck(data, 0);
      setTimeout(() => {
        if (e == 0) {
          window.scrollTo(0, 0);
        } else if (e == 1) {
          this.$el
            .querySelector("#com-1")
            .scrollIntoView({ block: "start", behavior: "smooth" });
        } else if (e == 2) {
          this.$el
            .querySelector("#com-2")
            .scrollIntoView({ block: "start", behavior: "smooth" });
        } else if (e == 3) {
          this.$el
            .querySelector("#com-3")
            .scrollIntoView({ block: "start", behavior: "smooth" });
        }
      }, 500);
    },
    toProduct(e) {
      //this.$router.push({ path: "/products" }, () => {});
      let data = {
        url: "/products",
      };
      this.tabCheck(data, 1);
      setTimeout(() => {
        if (e == 0) {
          window.scrollTo(0, 0);
        } else if (e == 1) {
          this.$el
            .querySelector("#prd-1")
            .scrollIntoView({ block: "start", behavior: "smooth" });
        } else if (e == 2) {
          this.$el
            .querySelector("#prd-2")
            .scrollIntoView({ block: "start", behavior: "smooth" });
        } else if (e == 3) {
          this.$el
            .querySelector("#prd-3")
            .scrollIntoView({ block: "start", behavior: "smooth" });
        } else if (e == 4) {
          this.$el
            .querySelector("#prd-4")
            .scrollIntoView({ block: "start", behavior: "smooth" });
        }
      }, 500);
    },
    toNews(e) {
      let data = {
        url: "/news",
      };
      this.tabCheck(data, 2);
      this.$nextTick(() => {
        if (e == 0) {
          window.scrollTo(0, 0);
        } else if (e == 1) {
          this.$el
            .querySelector("#news-1")
            .scrollIntoView({ block: "start", behavior: "smooth" });
          this.$children[1].tab[0].check = true;
          this.$children[1].tab[1].check = false;
          this.$children[1].tab[2].check = false;
          this.$children[1].changeNex(0);
        } else if (e == 2) {
          this.$el
            .querySelector("#news-1")
            .scrollIntoView({ block: "start", behavior: "smooth" });
          this.$children[1].tab[0].check = false;
          this.$children[1].tab[1].check = true;
          this.$children[1].tab[2].check = false;
          this.$children[1].changeNex(1);
        } else if (e == 3) {
          this.$el
            .querySelector("#news-1")
            .scrollIntoView({ block: "start", behavior: "smooth" });
          this.$children[1].tab[0].check = false;
          this.$children[1].tab[1].check = false;
          this.$children[1].tab[2].check = true;
          this.$children[1].changeNex(2);
        }
      });
    },
    toVideo(e) {
      let data = {
        url: "/video",
      };
      this.tabCheck(data, 3);
      this.$nextTick(() => {
        if (e == 0) {
          window.scrollTo(0, 0);
        } else if (e == 1) {
          this.$el
            .querySelector("#video-1")
            .scrollIntoView({ block: "start", behavior: "smooth" });
        } else if (e == 2) {
          this.$el
            .querySelector("#video-2")
            .scrollIntoView({ block: "start", behavior: "smooth" });
        } else if (e == 3) {
          this.$el
            .querySelector("#video-3")
            .scrollIntoView({ block: "start", behavior: "smooth" });
        }
      });
    },
    toServe(e) {
      let data = {
        url: "/serve",
      };
      this.tabCheck(data, 4);
      this.$nextTick(() => {
        if (e == 0) {
          window.scrollTo(0, 0);
        } else if (e == 1) {
          this.$el
            .querySelector("#serve-1")
            .scrollIntoView({ block: "start", behavior: "smooth" });
        } else if (e == 2) {
          this.$el
            .querySelector("#serve-2")
            .scrollIntoView({ block: "start", behavior: "smooth" });
        }
      });
    },
    goLink(data){
      let param = {
        key: 'CLICK',
        bizType: 17,
        itemId: data.id
      };
      setAction(param).then((res) => {
        if(data.url){
          window.open(data.url, '_blank')
        }
      });
     
    }
  },
};
</script>
<style scoped>
.botBei {
  display: flex;
  align-items: center;
  justify-content: center;
}
.beianImg {
  width: 15px;
  height: 15px;
  margin-left: 42px;
}
.friendly-link{
  padding:71px 260px 0 260px;
  background:#201F45;
}
.link-top{
  font-size:16px;
  color: #fff;
  padding-bottom:43px;
  text-align:center;
}
.link-box{
  display:flex;
  justify-content:center;;
  color:#999DA6;
  flex-wrap:wrap;

}
.link-item{
  margin:0 30px 10px 0;
  cursor:pointer;
}
.link-item:last-child{
  margin:0;

}
</style>



// WEBPACK FOOTER //
// src/pages/main/navBar.vue